export interface BuildInfo {
  commit: string;
  buildTime: string;
}

// Import build info from generated source file
// This is generated at build time to ensure it matches the source code
let buildInfo: BuildInfo | null = null;

try {
  // Try to import the generated build info
  const { buildInfo: generatedBuildInfo } = await import(
    '../generated/build-info.js'
  );
  buildInfo = generatedBuildInfo;
} catch (error) {
  // In development or if build info hasn't been generated yet, use fallback
  if (import.meta.env.DEV) {
    buildInfo = {
      commit: 'dev',
      buildTime: new Date().toISOString(),
    };
  } else {
    console.warn('Failed to load build info:', error);
  }
}

export async function getBuildInfo(): Promise<BuildInfo | null> {
  return buildInfo;
}
